import DOMPurify from 'dompurify';
import { WeeklyScheduleDaysDTO } from 'types/schedule/weeklySchedule';
import { weekDaysLabels } from 'consts/weekDaysLabels';
import { AppList } from 'components/atoms';

type WeeklyScheduleDaysListProps = {
    days: WeeklyScheduleDaysDTO[];
};

export const WeeklyScheduleDaysList = ({ days }: WeeklyScheduleDaysListProps) => {
    if (!days || days.length === 0) {
        return null;
    }

    return (
        <AppList.Item>
            {days.map((day) => {
                const dayLabel = weekDaysLabels[day.dayName];
                const dayDescription = day.description ? DOMPurify.sanitize(day.description) : '';

                return (
                    <div key={day.dayName} style={{ marginBottom: 12, marginRight: 16 }}>
                        <div style={{ fontWeight: 500, marginRight: 8 }}>{dayLabel}:</div>
                        {dayDescription && (
                            <span
                                style={{ fontSize: '14px' }}
                                // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
                                dangerouslySetInnerHTML={{ __html: dayDescription }}
                            />
                        )}
                    </div>
                );
            })}
        </AppList.Item>
    );
};
